import React from 'react';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';

const offset = 124;
const duration = '1s';

const SpinnerSvg = ({ className }) => {
    return (
        <svg
            className={className}
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                fill="none"
                stroke="currentcolor"
                strokeWidth="8"
                strokeLinecap="round"
                cx="24"
                cy="24"
                r="20"
            />
        </svg>
    );
};

export const Spinner = styled<any, any>(SpinnerSvg, 'spinner', 'base')`
    @keyframes rotator {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: ${offset};
        }
        50% {
            stroke-dashoffset: ${offset / 4};
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: ${offset};
            transform: rotate(360deg);
        }
    }

    ${propStyles};

    animation: rotator ${duration} linear infinite;

    circle {
        stroke: currentcolor;
        stroke-dasharray: ${offset};
        stroke-dashoffset: -36;
        transform-origin: center;
        animation: dash ${duration} ease-in-out infinite;
    }
`;

Spinner.defaultProps = {
    color: 'inherit',
    iconSize: '24px',
};



// WEBPACK FOOTER //
// ./src/Components/Spinner.tsx